define('app/selcomm/filter/selcomm-filter-service',[],function () {
    "use strict";
    // Legacy support
	var asArray = Function.call.bind(Array.prototype.slice);
	var namespace = "Filters.",
		filters = {
			equals: function equals(propertyName, value) {
				return this.BasicPropertyFilter(propertyName, "==", value);
			},
			notEquals: function equals(propertyName, value) {
				return this.BasicPropertyFilter(propertyName, "!=", value);
			},
			greaterThan: function equals(propertyName, value) {
				return this.BasicPropertyFilter(propertyName, ">", value);
			},
			greaterThanOrEquals: function equals(propertyName, value) {
				return this.BasicPropertyFilter(propertyName, ">=", value);
			},
			lessThan: function equals(propertyName, value) {
				return this.BasicPropertyFilter(propertyName, "<", value);
			},
			lessThanOrEquals: function equals(propertyName, value) {
				return this.BasicPropertyFilter(propertyName, "<=", value);
			}
		};
	function addFilter(jsName, selcommName, fn) {
		// The evaluator is for demo purposes at this stage only.
		switch (arguments.length) {
			case 2:
				fn = selcommName;
				selcommName = jsName;
				break;
		}
		wrappedFilter.$type = namespace + selcommName;
		(Array.isArray(jsName) ? jsName : [jsName]).concat(selcommName).forEach(function (jsName) {
			filters[jsName] = wrappedFilter;
		});
		function wrappedFilter() {
			var newFilter = {};
			var retVal = fn.apply(newFilter, arguments) || newFilter;
			retVal.$type = wrappedFilter.$type;
			Object.defineProperties(retVal, {
				negate: {
					enumerable: false,
					value: retVal.negate || selcommFilterService.not.bind(selcommFilterService, retVal)
				},
				or: {
					enumerable: false,
					value: retVal.or || selcommFilterService.any.bind(selcommFilterService, retVal)
				},
				and: {
					enumerable: false,
					value: retVal.and || selcommFilterService.all.bind(selcommFilterService, retVal)
				}
			})
			return retVal;
		}
	}
	addFilter("not", "NotFilter", function NotFilter(filter) {
		this.Filter = filter;
		this.negate = function negate() {
			return this.Filter;
		}.bind(this);
	});
	addFilter("any", "AnyFilterGroup", function AnyFilterGroup() {
		this.Filters = asArray(arguments).filter(truthy);
		this.or = function or() {
			return selcommFilterService.any.apply(selcommFilterService,  this.Filters.concat(asArray(arguments)));
		}.bind(this);
	});
	addFilter("all", "AllFilterGroup", function AllFilterGroup() {
		this.Filters = asArray(arguments).filter(truthy);
		this.and = function and() {
			return selcommFilterService.all.apply(selcommFilterService,  this.Filters.concat(asArray(arguments)));
		}.bind(this);
	});
	addFilter(["basic", "compare"], "BasicPropertyFilter", function BasicPropertyFilter(propertyName, compareOperator, value) {
		this.PropertyName = propertyName;
		switch (arguments.length) {
			case 1:
				compareOperator = "=";
				value = null;
				break;
			case 2:
				compareOperator = "=";
				value = value;
				break;
		}
		compareOperator = (function (op) {
			switch (op) {
				case "equals": case "=": case "==":
					return "Equals";
				case "greaterthan": case ">":
					return "GreaterThan";
				case "greaterthanorequals": case ">=":
					return "GreaterThanOrEquals";
				case "lessthan": case "<":
					return "LessThan";
				case "lessthanorequals": case "<=":
					return "LessThanOrEquals";
				case "notequals": case "!=":
					return "NotEquals";
				default:
					return op;
			}
		}(compareOperator.toLowerCase()));
		this.CompareOperator = compareOperator;
		this.Value = angular.isDefined(value) ? value : null;
	});
	addFilter(["between", "range"], "BetweenPropertyFilter", function BetweenPropertyFilter(propertyName, startValue, endValue) {
		this.PropertyName = propertyName;
		this.StartValue = angular.isDefined(startValue) ? startValue : null;
		this.EndValue = angular.isDefined(endValue) ? endValue : null;
	});
	addFilter(["keyword", "contains"], "KeywordPropertyFilter", function KeywordPropertyFilter(propertyName, value) {
		this.PropertyName = propertyName;
		this.Value = value;
	});
	addFilter("in", "InPropertyFilter", function BetweenPropertyFilter(propertyName, values) {
		this.PropertyName = propertyName;
		this.Values = values;
	});

	addFilter("exists", "ExistsFilter", function ExistsFilter(filter) {
		this.Filter = filter;
	});

	// Not technically a filter
	addFilter("this", "ThisReference", function ThisReference(propertyName) {
		this.PropertyName = propertyName;
	});

	var selcommFilterService = Object.create(filters);

	return selcommFilterService;
	function truthy(val) {
		return !!val;
	}
});
